<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <c-card title="Editar ordenamiento">
          <ordenamiento-form />
        </c-card>
      </div>
    </div>
  </div>
</template>
<script>
import OrdenamientoForm from "@/components/Forms/OrdenamientoForm";
import CCard from "@/components/CCard.vue";

export default {
  components: {
    OrdenamientoForm,
    CCard,
  },
};
</script>
